import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SEO from "../Common/SEO";
import ExploreFilter from "../Explore/ExploreFilter";
import ExploreList from "../Explore/ExploreList";
import ExploreLiveItem from "../Explore/ExploreLiveItem";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import { SESSION_AUTH } from "../../common/auth";
import { COMPANY_SERVICES } from "../../services";

const CompanyEventsLanding = props => {
  const { orgSlug } = useParams();
  const { orgId, orgName } = props;

  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();

  const [loading, setLoading] = useState(false);
  const dataFetchedRef = useRef(false);
  const [listData, setListData] = useState([]);
  const [textSearch, setTextSearch] = useState("");

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    setLoading(true);

    COMPANY_SERVICES.eventsLanding({
      id: orgId,
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      search: textSearch,
    })
      .then(data => {
        if (data.code === 200) {
          setListData(data.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
        dataFetchedRef.current = false;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textSearch, isUserSession]);

  useEffect(() => {
    if (textSearch) {
      dataFetchedRef.current = false;
    }
  }, [textSearch]);
  return (
    <React.Fragment>
      <SEO title={`${orgName || "Profile"} |  Events`} />

      <ExploreFilter setTextSearch={setTextSearch} textSearch={textSearch} />

      <div className="event-page-explore-content mb-20">
        {listData?.live ? (
          <ExploreLiveItem listData={listData?.live?.[0]} />
        ) : null}
        {listData?.replays ? (
          <>
            <div className="event-page-explore-content-typeHeader">
              <div className="event-page-explore-content-typeHeader-heading">
                Recent Live Streams
              </div>
              <Link
                to={`/company/${orgSlug}/events/list/replays`}
                className="event-page-explore-content-typeHeader-btn"
              >
                View all
              </Link>
            </div>
            <ExploreList
              layout3={true}
              loading={loading}
              listData={listData?.replays}
            />
          </>
        ) : null}

        {listData?.upcoming ? (
          <>
            <div className="event-page-explore-content-typeHeader">
              <div className="event-page-explore-content-typeHeader-heading">
                Upcoming
              </div>
              <Link
                to={`/company/${orgSlug}/events/list/upcoming`}
                className="event-page-explore-content-typeHeader-btn"
              >
                View all
              </Link>
            </div>
            <ExploreList
              layout3={true}
              loading={loading}
              listData={listData?.upcoming}
            />
          </>
        ) : null}

        {listData?.demand ? (
          <>
            <div className="event-page-explore-content-typeHeader">
              <div className="event-page-explore-content-typeHeader-heading">
                Pending Replay
              </div>
              <Link
                to={`/company/${orgSlug}/events/list/get-notified-of-replays`}
                className="event-page-explore-content-typeHeader-btn"
              >
                View all
              </Link>
            </div>
            <ExploreList
              layout3={true}
              loading={loading}
              listData={listData?.demand}
            />
          </>
        ) : null}
        {loading ? <FullPageProgress fixed={true} /> : null}
      </div>
    </React.Fragment>
  );
};

export default CompanyEventsLanding;
